import { render } from "./creditos.vue?vue&type=template&id=50d69e42&scoped=true"
import script from "./creditos.vue?vue&type=script&lang=js"
export * from "./creditos.vue?vue&type=script&lang=js"

import "./creditos.vue?vue&type=style&index=0&id=50d69e42&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d69e42"]])

export default __exports__